<template>
    <div class="web accountNumber">
        <el-row>
            <el-col :span="4">
                <div class="tabList">
                    <div class="accTitle">账号设置</div>
                    <el-tabs tab-position="left" v-model="tabActive">
                        <el-tab-pane label="手机号码" name="1"></el-tab-pane>
                        <el-tab-pane label="微信号" name="2"></el-tab-pane>
                        <el-tab-pane label="隐私设置" name="3" v-if="port === 'teacher'"></el-tab-pane>
                    </el-tabs>
                </div>
            </el-col>
            <el-col :span="20">
                <div class="accountNumberBox">
                    <accPhone v-if="tabActive === '1'" />
                    <weChatNum v-if="tabActive === '2'" />
                    <div class="Privacy" v-if="tabActive === '3'">
                        <div class="PrivacyTitle">隐藏简历设置</div>
                        <div class="PrivacyBox">隐藏简历
                            <el-switch v-model="vList.status" :active-value="0" :inactive-value="1" @change="PrivacyChange"></el-switch>
                        </div>
                        <el-divider></el-divider>
                        <div class="PrivacyTitle">屏蔽公司</div>
                        <div class="shield">添加屏蔽公司后，你和这些园所的园长，都不会被相互推荐，你的查看行为也不会告知对方</div>
                        <div class="shield">
                            <el-select
                                style="width: 564px;"
                                v-model="sid"
                                filterable
                                remote
                                reserve-keyword
                                placeholder="搜索公司全称"
                                @change="shield"
                                :remote-method="remoteMethod">
                                <el-option
                                    v-for="(item,index) in schoolList"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.sid">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="shield shieldTitle">已经屏蔽&nbsp;{{shieldSchool.length}}&nbsp;家园所</div>
                        <div class="shieldBox">
                            <div class="shieldName clearfix" v-for="(item, index) in shieldSchool" :key="index">
                                <div class="fl">{{item.name}}</div>
                                <div class="fr shieldBtn">
                                    <el-popconfirm title="确定解除屏蔽？" @confirm="relieve(item,index)">
                                        <el-button slot="reference" type="primary" plain size="mini">解除屏蔽</el-button>
                                    </el-popconfirm>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import accPhone from "@/components/accPhone"
    import weChatNum from "@/components/weChatNum"
    export default {
        components: {
            accPhone,
            weChatNum
        },
        data() {
            return {
                tabActive: '1',
                Privacy: 1,
                schoolList: [],
                sid: '',
                shieldSchool: [],
                port: sessionStorage.getItem('port'),
                vList: {}
            }
        },
        mounted() {
            // 从简历进来设置隐私
            this.tabActive = this.$route.query.tabActive?this.$route.query.tabActive:'1'
            if(this.port === 'teacher') {
                this.api.get('/5cf3c3436edc5', {}).then(r=> {
                    this.vList = r.data.list[0]
                })
                this.getShield()
            }
        },
        methods: {

            // 搜索园所
            remoteMethod(e) {
                if(e) {
                    let obj = {
                        name: e
                    }
                    this.api.get('/5d8c77c595477', obj).then(r=> {
                        this.schoolList = r.data.data
                    })
                }
            },

            // 隐藏简历
            PrivacyChange(e) {
                if(this.vList.vid) {
                    let obj = {
                        status: e,
                        vid: this.vList.vid
                    }
                    this.api.get('/5cf3c4814206c', obj).then(r=> {
                        this.$message({
                            message: e === 1?'打开成功':'隐藏成功',
                            type: 'success'
                        });
                    })
                }
            },

            // 屏蔽园所
            shield(e) {
                let obj = {
                    sid: e
                }
                this.api.get('/5d8c77ec9d7cc', obj).then(r=> {
                    this.$message({
                        message: r.msg,
                        type: 'success'
                    });
                    this.getShield()
                })
            },

            // 获取屏蔽园所
            getShield() {
                this.api.get('/5d8c7a434b58e', {}).then(r=> {
                    this.shieldSchool = r.data.list
                })
            },

            // 解除屏蔽
            relieve(o,i) {
                this.api.get('/5d8c780427504', { id: o.id }).then(r=> {
                    this.shieldSchool.splice(i,1)
                    this.$message({
                        message: r.msg,
                        type: 'success'
                    });
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .accountNumber {
        background: white;
        margin-top: 20px;
        .tabList {
            min-height: 100vh;
            background: #f8f9fb;
        }
        .accTitle {
            text-align: center;
            font-size: 20px;
            padding: 30px 0;
        }
        .accountNumberBox {
            min-height: 100vh;
        }
    }
    .Privacy {
        padding: 30px 50px;
        .PrivacyTitle {
            font-size: 24px;
        }
        .PrivacyTitle:first-child {
            padding-top: 0;
        }
        .PrivacyBox {
            padding-top: 30px;
            font-size: 14px;
        }
        .shield {
            font-size: 14px;
            padding-top: 20px;
        }
        .shieldTitle {
            font-size: 16px;
        }
        .shieldName {
            font-size: 14px;
            margin-top: 10px;
            height: 40px;
            line-height: 40px;
            padding: 0 10px;
        }
        .shieldName:hover {
            background: #f6f7fa;
            .shieldBtn {
                display: block;
            }
        }
        .shieldBtn {
            display: none;
        }
    }
</style>

<style lang="scss">
    .accountNumber {
        .el-tabs__nav {
            width: 100%;;
            background: #f8f9fb;
        }
        .el-tabs--left .el-tabs__item.is-left{
            text-align: center;
        }
        .el-tabs__header {
            width: 100%;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/job/accountNumber.vue